import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getLazyTree, getDetail, submit, remove } from "@/api/base/region";
import { mapGetters } from "vuex";
import { validatenull } from "@/util/validate";
import { getToken } from "@/util/auth";
export default {
  data: function data() {
    return {
      topCode: '00',
      treeCode: '',
      treeParentCode: '',
      treeData: [],
      treeOption: {
        nodeKey: 'id',
        lazy: true,
        treeLoad: function treeLoad(node, resolve) {
          var parentCode = node.level === 0 ? "00" : node.data.id;
          getLazyTree(parentCode).then(function (res) {
            resolve(res.data.data.map(function (item) {
              return _objectSpread(_objectSpread({}, item), {}, {
                leaf: !item.hasChildren
              });
            }));
          });
        },
        addBtn: false,
        menu: false,
        size: 'small',
        props: {
          labelText: '标题',
          label: 'title',
          value: 'value',
          children: 'children'
        }
      },
      regionForm: {},
      regionOption: {
        labelWidth: 100,
        column: [{
          label: "父区划编号",
          prop: "parentCode",
          span: 24,
          disabled: true,
          rules: [{
            required: true,
            message: "请输入父区划编号",
            trigger: "blur"
          }]
        }, {
          label: "父区划名称",
          prop: "parentName",
          span: 24,
          disabled: true
        }, {
          label: "区划编号",
          prop: "code",
          formslot: true,
          span: 24,
          rules: [{
            required: true,
            message: "请输入区划编号",
            trigger: "blur"
          }]
        }, {
          label: "区划子编号",
          prop: "subCode",
          display: false
        }, {
          label: "区划名称",
          prop: "name",
          span: 24,
          rules: [{
            required: true,
            message: "请输入区划名称",
            trigger: "blur"
          }]
        }, {
          label: "区划等级",
          prop: "regionLevel",
          type: "radio",
          dicUrl: "/api/blade-system/dict/dictionary?code=region",
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          dataType: "number",
          span: 24,
          rules: [{
            required: true,
            message: "请选择区划等级",
            trigger: "blur"
          }]
        }, {
          label: "区划排序",
          prop: "sort",
          type: "number",
          span: 24,
          rules: [{
            required: true,
            message: "请输入区划排序",
            trigger: "blur"
          }]
        }, {
          label: "区划备注",
          prop: "remark",
          type: "textarea",
          minRows: 6,
          span: 24
        }]
      },
      excelBox: false,
      excelForm: {},
      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [{
          label: '模板上传',
          prop: 'excelFile',
          type: 'upload',
          drag: true,
          loadText: '模板上传中，请稍等',
          span: 24,
          propsHttp: {
            res: 'data'
          },
          tip: '请上传 .xls,.xlsx 标准格式文件',
          action: "/api/blade-system/region/import-region"
        }, {
          label: "数据覆盖",
          prop: "isCovered",
          type: "switch",
          align: "center",
          width: 80,
          dicData: [{
            label: "否",
            value: 0
          }, {
            label: "是",
            value: 1
          }],
          value: 0,
          slot: true,
          rules: [{
            required: true,
            message: "请选择是否覆盖",
            trigger: "blur"
          }]
        }, {
          label: '模板下载',
          prop: 'excelTemplate',
          formslot: true,
          span: 24
        }]
      },
      debugBox: false,
      debugForm: {},
      debugOption: {
        labelWidth: 50,
        submitBtn: false,
        emptyBtn: false,
        column: [{
          label: '省份',
          prop: 'province',
          type: 'select',
          props: {
            label: 'name',
            value: 'code'
          },
          cascaderItem: ['city', 'district'],
          dicUrl: '/api/blade-system/region/select',
          span: 24
        }, {
          label: '地市',
          prop: 'city',
          type: 'select',
          props: {
            label: 'name',
            value: 'code'
          },
          dicFlag: false,
          dicUrl: '/api/blade-system/region/select?code={{key}}',
          span: 24
        }, {
          label: '区县',
          prop: 'district',
          type: 'select',
          props: {
            label: 'name',
            value: 'code'
          },
          dicFlag: false,
          dicUrl: '/api/blade-system/region/select?code={{key}}',
          span: 24
        }]
      }
    };
  },
  watch: {
    'regionForm.subCode': function regionFormSubCode() {
      this.regionForm.code = this.regionForm.parentCode + this.regionForm.subCode;
    },
    'excelForm.isCovered': function excelFormIsCovered() {
      if (this.excelForm.isCovered !== '') {
        var column = this.findObject(this.excelOption.column, "excelFile");
        column.action = "/api/blade-system/region/import-region?isCovered=".concat(this.excelForm.isCovered);
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["permission"])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: this.vaildData(this.permission.region_add, false),
        viewBtn: this.vaildData(this.permission.region_view, false),
        delBtn: this.vaildData(this.permission.region_delete, false),
        editBtn: this.vaildData(this.permission.region_edit, false)
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  }),
  methods: {
    initTree: function initTree() {
      var _this = this;

      this.treeData = [];
      getLazyTree(this.topCode).then(function (res) {
        _this.treeData = res.data.data.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            leaf: !item.hasChildren
          });
        });
      });
    },
    nodeClick: function nodeClick(data) {
      var _this2 = this;

      var column = this.findObject(this.regionOption.column, "parentCode");
      column.disabled = true;
      this.treeCode = data.id;
      this.treeParentCode = data.parentId;
      getDetail(this.treeCode).then(function (res) {
        _this2.regionForm = res.data.data;
        _this2.regionForm.subCode = _this2.regionForm.code.replace(_this2.regionForm.parentCode, '');
      });
    },
    addChildren: function addChildren() {
      if (validatenull(this.regionForm.code) || validatenull(this.regionForm.name)) {
        this.$message.warning("请先选择一项区划");
        return;
      }

      this.regionForm.parentCode = this.regionForm.code;
      this.regionForm.parentName = this.regionForm.name;
      this.regionForm.code = '';
      this.regionForm.subCode = '';
      this.regionForm.name = '';
      this.regionForm.regionLevel = this.regionForm.regionLevel === 5 ? 5 : this.regionForm.regionLevel + 1;
    },
    handleSubmit: function handleSubmit(form, done, loading) {
      var _this3 = this;

      var parentCode = form.parentCode === this.topCode ? '' : form.parentCode;
      form.code = parentCode + form.subCode;
      submit(form).then(function () {
        _this3.$message({
          type: "success",
          message: "操作成功!"
        });

        _this3.initTree();

        _this3.regionForm.subCode = '';

        _this3.$refs.form.resetForm();

        done();
      }, function (error) {
        loading();
        window.console.log(error);
      });
    },
    handleDelete: function handleDelete() {
      var _this4 = this;

      if (validatenull(this.regionForm.code)) {
        this.$message.warning("请先选择一项区划");
        return;
      }

      this.$confirm("\u786E\u5B9A\u5C06 [".concat(this.regionForm.name, "] \u6570\u636E\u5220\u9664?"), {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this4.treeCode);
      }).then(function () {
        _this4.$message({
          type: "success",
          message: "操作成功!"
        });

        _this4.initTree();

        _this4.regionForm.subCode = '';

        _this4.$refs.form.resetForm();
      });
    },
    uploadAfter: function uploadAfter(res, done, loading, column) {
      window.console.log(column);
      this.excelBox = false;
      this.initTree();
      done();
    },
    handleDebug: function handleDebug() {
      this.debugBox = true;
    },
    handleImport: function handleImport() {
      this.excelBox = true;
    },
    handleExport: function handleExport() {
      var _this5 = this;

      this.$confirm("是否导出行政区划数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        window.open("/api/blade-system/region/export-region?".concat(_this5.website.tokenHeader, "=").concat(getToken()));
      });
    },
    handleTemplate: function handleTemplate() {
      window.open("/api/blade-system/region/export-template?".concat(this.website.tokenHeader, "=").concat(getToken()));
    }
  }
};